/**
 * Testimonials block — front-end interactivity (viewScript, loaded only on
 * pages that use this block).
 *
 * Initializes one Swiper instance per `[data-qr-part="carousel"]` wrapper
 * found on the page, scoping the pagination lookup to each wrapper via
 * querySelector rather than a global class — so multiple instances of this
 * block on one page never collide, same principle as data-qr-header on the
 * site-header block. Always one quote per slide, auto-advancing every 2s.
 */
import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

function initTestimonialCarousels() {
	document.querySelectorAll('[data-qr-part="carousel"]').forEach((carousel) => {
		const swiperEl = carousel.querySelector('.qr-testimonials-swiper');
		if (!swiperEl || swiperEl.swiper) {
			return; // No slides, or already initialized.
		}

		new Swiper(swiperEl, {
			modules: [Pagination, Autoplay],
			slidesPerView: 1,
			grabCursor: true,
			autoplay: {
				delay: 2000,
				disableOnInteraction: true,
			},
			pagination: {
				el: carousel.querySelector('[data-qr-part="pagination"]'),
				clickable: true,
			},
		});
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initTestimonialCarousels);
} else {
	initTestimonialCarousels();
}
